import { parseCurrency } from '@helper/parseCurrency'

export const parseCommercialBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'orcamento-id': item.id,
      'orcamento-ano': item.ano,
      'orcamento-mes': item.mes,
      'orcamento-empresa': item.empresaId + '-' + item.empresaDescricao,
      'orcamento-loja': item.lojaId + '-' + item.lojaDescricao,
      'orcamento-categoria': item.categoriaId + '-' + item.categoriaDescricao,
      'orcamento-fator-venda': parseCurrency({
        value: item.fatorVendaBruta,
        country: 'pt-br'
      }),
      'orcamento-real-proj': parseCurrency({
        value: item.previsaoAnoAtual,
        country: 'pt-br'
      }),
      'orcamento-prev-orcamento': parseCurrency({
        value: item.previsaoAlgoritmo ? item.previsaoAlgoritmo : 0,
        country: 'pt-br'
      }),
      'orcamento-alterado': item.alterado ? item.alterado : false,
      'orcamento-crescimento': item.previsaoAumentoPercentual,
      'orcamento-ajustado': parseCurrency({
        value: item.previsaoAlgoritmo,
        country: 'pt-br'
      }),
      'orcamento-crescimento-ajustado': parseCurrency({
        value: item.previsaoAumentoPercentualAjusteFino
          ? item.previsaoAumentoPercentualAjusteFino
          : 0,
        country: 'pt-br'
      }),
      'orcamento-du-real-proj': parseCurrency({
        value: item.duPrevisaoAnoAtual ? item.duPrevisaoAnoAtual : 0,
        country: 'pt-br'
      }),
      'orcamento-du-prev-orcamento': parseCurrency({
        value: item.duPrevisaoAjusteFino ? item.duPrevisaoAjusteFino : 0,
        country: 'pt-br'
      }),
      'orcamento-du-ajustado': parseCurrency({
        value: item.duPrevisaoAjusteFino ? item.duPrevisaoAjusteFino : 0,
        country: 'pt-br'
      }),
      'orcamento-du-crescimento-ajustado': parseCurrency({
        value: item.duRealizadoAnoPassado ? item.duRealizadoAnoPassado : 0,
        country: 'pt-br'
      })
    })
  }

  return res
}
